import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const mapToServerObject = modifierSet => {
    const data = _.omit(modifierSet, ['products', 'modifiers']);

    const modifiers = modifierSet.modifiers.map(m => {
        if (m.mode == 0) m.amount = 0;
        return m;
    });

    data.products = modifierSet.products.map(obj => obj.id);
    data.modifiers = modifiers;

    return data;
};

const getters = {
    modifierSetList: state => {
        return state.modifierSetList;
    },

    modifierSet: state => {
        return state.modifierSet;
    },

    totalPreSelected(state) {
        return state.modifierSet.modifiers.filter(m => m.pre_selected).length;
    },

    getPreselectedModifiers() {
        return state.modifierSet.modifiers
            .map((m, idx) => Object.assign(m, { original_index: idx }))
            .filter(m => m.pre_selected);
    },

    modifierExists() {
        return state.modifierSet.id !== null;
    },

    hasMultipleModifier(state) {
        return state.modifierSet.modifiers.length > 1;
    },

    modes: () => {
        return [
            { name: 'Instruction', id: 0 },
            { name: 'Topup', id: 1 },
            { name: 'Deduct', id: 2 },
            { name: 'Discount', id: 3 },
        ];
    },

    attributes: () => {
        return {
            id: null,
            name: null,
            min_apply_limit: 0,
            max_apply_limit: 0,
            modifiers: [
                {
                    name: null,
                    mode: 0,
                    amount: '0.00',
                    pre_selected: false,
                    sequence: 1,
                },
            ],
            products: [],
        };
    },
};

const state = {
    modifierSetList: [],
    modifierSet: getters.attributes(),
};

const mutations = {
    [type.SET_MODIFIER_SET_LIST](state, modifierSetList) {
        state.modifierSetList = modifierSetList;
    },

    [type.ADD_MODIFIER_SET](state, modifierSet) {
        state.modifierSetList.push(modifierSet);
    },

    [type.SET_MODIFIER_SET](state, modifierSet) {
        state.modifierSet = modifierSet;
    },

    [type.SET_MODIFIERS_SEQUENCE](state, sort = false) {
        if (sort) {
            state.modifierSet.modifiers = _.sortBy(
                state.modifierSet.modifiers,
                m => m.sequence,
            );
        }

        state.modifierSet.modifiers.forEach((m, idx) => {
            m.sequence = ++idx;
        });
    },

    [type.SET_MODIFIER_SET_ATTRIBUTE](
        state,
        { attribute, value, modifier_attr = null, modifier_index = null } = {},
    ) {
        if (attribute !== 'modifiers') {
            state.modifierSet[attribute] = value;
        } else {
            state.modifierSet[attribute][modifier_index][modifier_attr] = value;
        }
    },

    [type.ADD_MODIFIER](state) {
        state.modifierSet.modifiers.push({
            name: null,
            mode: 0,
            amount: '0.00',
            pre_selected: false,
            sequence: state.modifierSet.modifiers.length + 1,
        });
    },

    [type.REMOVE_MODIFIER](state, modifier_index) {
        state.modifierSet.modifiers.splice(modifier_index, 1);
    },

    [type.SET_MODIFIERS](state, modifiers) {
        state.modifierSet.modifiers = modifiers;
    },
};

const actions = {
    getModifierSetList({ commit, dispatch }) {
        let api = Laroute.route('franchise.vue.getmodifiersetsselect');
        startLoading(dispatch, 'fetch-modifier-sets');

        return axios.get(api).then(res => {
            endLoading(dispatch, 'fetch-modifier-sets');

            let data = res.data.data;
            commit(type.SET_MODIFIER_SET_LIST, data);

            return res;
        });
    },

    setModifier({ commit }, modifier) {
        commit(type.SET_MODIFIER_SET, data);
    },

    addModifier({ commit }) {
        commit(type.ADD_MODIFIER);
    },

    addModifierSet({ commit }, modifierSet) {
        commit(type.ADD_MODIFIER_SET, modifierSet);
    },

    removeModifier({ commit }, modifier_index) {
        commit(type.REMOVE_MODIFIER, modifier_index);
    },

    setModifiers({ commit }, modifiers) {
        commit(type.SET_MODIFIERS, modifiers);
    },

    /**
     * @param {Object} input
     */
    setModifierSetAttribute({ commit }, input) {
        commit(type.SET_MODIFIER_SET_ATTRIBUTE, input);
    },

    createModifierSet({ commit, state, dispatch }) {
        let api = Laroute.route('franchise.inventory.modifier.store');
        startLoading(dispatch, 'save-modifier-sets');

        commit(type.SET_MODIFIERS_SEQUENCE);

        return axios
            .post(api, mapToServerObject(state.modifierSet))
            .then(res => {
                endLoading(dispatch, 'save-modifier-sets');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-modifier-sets');
                throw err;
            });
    },

    updateModifierSet({ commit, state, dispatch }) {
        let api = Laroute.route('franchise.inventory.modifier.update', {
            id: state.modifierSet.id,
        });
        startLoading(dispatch, 'save-modifier-sets');

        commit(type.SET_MODIFIERS_SEQUENCE);

        return axios
            .patch(api, mapToServerObject(state.modifierSet))
            .then(res => {
                endLoading(dispatch, 'save-modifier-sets');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-modifier-sets');
                throw err;
            });
    },

    getModifierSet({ commit, dispatch }, id) {
        let route = Laroute.route('franchise.inventory.modifier.show', {
            id: id,
        });
        startLoading(dispatch, 'fetch-modifier-sets');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-modifier-sets');
                commit(type.SET_MODIFIER_SET, res.data.data);
                commit(type.SET_MODIFIERS_SEQUENCE, true);

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-modifier-sets');
                throw err;
            });
    },

    resetModifierSet({ commit }) {
        commit(type.SET_MODIFIER_SET, getters.attributes());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/modifierSet.js